import { AbstractModel } from '@uzurv/core';
import { inheritSerialization, autoserialize, autoserializeAs } from 'cerialize';
import { OperationsAlertCategory } from './operations-alert-category';

@inheritSerialization(AbstractModel)
export class OperationsAlertType extends AbstractModel {
  @autoserialize
  objectName: string;

  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserializeAs(OperationsAlertCategory)
  operationsAlertCategory: OperationsAlertCategory;

  @autoserialize
  priority: number;
}
